@if (crossAssessments.length > 0) {
  <h2 class="assessments-header">みんなからのコメント</h2>
  @for (assessment of crossAssessments; track assessment.id; let isFirst = $first) {
    <app-student-assessment-detail [assessment]="assessment" [isFirst]="isFirst"> </app-student-assessment-detail>
  }
} @else {
  <p class="no-cross-assement">みんなからのコメントが表示されます。</p>
}
